module.exports = __webpack_public_path__ + "static/02-7f24838e4b56cebddb2d75072234918d.jpg";